import type { Review } from '../../../types/Review';

export const getOverallRating = (review: Review): number | undefined =>
  review.ratings?.overall?.rating ?? review.overallRating;
